import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "itemizedBills", "billsPopup", "arrow", "submitButton", "durationSelect" ]
  static values = {
    costPerVideo5Seconds: { type: Number, default: 0.5 },
    costPerVideo10Seconds: { type: Number, default: 1.0 },
    klingCostPerVideo5Seconds: { type: Number, default: 0.5 },
    klingCostPerVideo10Seconds: { type: Number, default: 1.0 },
    hunyuanCostPerVideo5Seconds: { type: Number, default: 0.8 },
    hunyuanCostPerVideo10Seconds: { type: Number, default: 1.5 }
  }

  connect() {
    // Initialize cost values based on the current provider
    this.initializeProviderCosts()
    this.calculateCosts()
  }

  initializeProviderCosts() {
    // Find the provider select element
    const providerSelect = document.querySelector('select[name="video_generation_task[provider]"]')
    if (providerSelect) {
      const provider = providerSelect.value
      
      if (provider === "hunyuan") {
        this.costPerVideo5SecondsValue = this.hunyuanCostPerVideo5SecondsValue
        this.costPerVideo10SecondsValue = this.hunyuanCostPerVideo10SecondsValue
      } else {
        this.costPerVideo5SecondsValue = this.klingCostPerVideo5SecondsValue
        this.costPerVideo10SecondsValue = this.klingCostPerVideo10SecondsValue
      }
    }
  }

  disconnect() {
    // Clean up event listeners if needed
  }

  toggleBills(event) {
    event.preventDefault()
    this.billsPopupTarget.classList.toggle("hidden")
    this.arrowTarget.classList.toggle("rotate-180")
  }

  updateProviderCosts(event) {
    const provider = event.target.value
    
    if (provider === "hunyuan") {
      this.costPerVideo5SecondsValue = this.hunyuanCostPerVideo5SecondsValue
      this.costPerVideo10SecondsValue = this.hunyuanCostPerVideo10SecondsValue
    } else {
      this.costPerVideo5SecondsValue = this.klingCostPerVideo5SecondsValue
      this.costPerVideo10SecondsValue = this.klingCostPerVideo10SecondsValue
    }
    
    this.calculateCosts()
  }

  calculateCosts() {
    const duration = this.durationSelectTarget.value
    
    let cost
    if (duration === "5") {
      cost = parseFloat(this.costPerVideo5SecondsValue) || 0.5
    } else if (duration === "10") {
      cost = parseFloat(this.costPerVideo10SecondsValue) || 1.0
    } else {
      cost = parseFloat(this.costPerVideo5SecondsValue) || 0.5 // default to 5s cost
    }
    
    // Update the button text while preserving the icon
    if (this.submitButtonTarget) {
      const existingIcon = this.submitButtonTarget.querySelector("svg")
      this.submitButtonTarget.innerHTML = ""
      if (existingIcon) {
        this.submitButtonTarget.appendChild(existingIcon)
      }
      const textSpan = document.createElement("span")
      textSpan.textContent = `Generate (${cost} Credits)`
      textSpan.className = "ml-2" // Add some spacing after the icon
      this.submitButtonTarget.appendChild(textSpan)
    }
    
    // Update the itemized bills
    this.itemizedBillsTarget.innerHTML = this.generateItemizedBillsHTML(duration, cost)
  }

  generateItemizedBillsHTML(duration, cost) {
    return `
      <div class="space-y-2">
        <div class="flex justify-between items-center">
          <div class="text-gray-300">
            Video Generation (${duration} seconds)
          </div>
          <div class="text-gray-300">
            1 × ${cost} credits
          </div>
        </div>
        <div class="border-t border-gray-700"></div>
        <div class="flex justify-between items-center">
          <div class="text-gray-300 font-medium">
            Total
          </div>
          <div class="text-gray-300 font-medium flex items-center gap-1">
            ${cost} credits
            <div class="group relative">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 text-gray-500">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd" />
              </svg>
              <div class="absolute bottom-full mb-2 w-48 p-2 bg-gray-900 rounded-lg shadow-lg text-xs text-gray-300 hidden group-hover:block">
                This is the total cost that will be deducted from your credits when generating the video.
              </div>
            </div>
          </div>
        </div>
      </div>
    `
  }
} 